import { useMemo } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const TOOLBAR_FULL = [
  [{ header: [1, 2, 3, false] }],
  [{ font: [] }],
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  ["blockquote"],
  ["clean"],
];

const TOOLBAR_COMPACT = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline"],
  [{ color: [] }],
  [{ align: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  ["clean"],
];

const FORMATS = [
  "header", "font", "bold", "italic", "underline", "strike",
  "color", "background", "align", "list", "indent", "blockquote",
];

const RichTextEditor = ({
  value = "",
  onChange,
  placeholder = "",
  compact = false,
  minHeight = "120px",
  disabled = false,
  testId = "rich-editor",
}) => {
  const modules = useMemo(() => ({
    toolbar: compact ? TOOLBAR_COMPACT : TOOLBAR_FULL,
  }), [compact]);

  return (
    <div
      className={`rich-editor-wrapper ${disabled ? "opacity-60 pointer-events-none" : ""}`}
      data-testid={testId}
      style={{ "--editor-min-height": minHeight }}
    >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={FORMATS}
        placeholder={placeholder}
        readOnly={disabled}
      />
      <style>{`
        .rich-editor-wrapper .ql-container {
          min-height: var(--editor-min-height, 120px);
          font-size: 14px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        .rich-editor-wrapper .ql-toolbar {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          background: #f8fafc;
          border-color: #e2e8f0;
        }
        .rich-editor-wrapper .ql-container {
          border-color: #e2e8f0;
        }
        .rich-editor-wrapper .ql-editor {
          min-height: var(--editor-min-height, 120px);
          line-height: 1.6;
        }
        .rich-editor-wrapper .ql-editor.ql-blank::before {
          color: #94a3b8;
          font-style: normal;
        }
      `}</style>
    </div>
  );
};

export { RichTextEditor };
